<form class="uploadForm" [formGroup]="uploadForm">
  <div class="row">
    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="form-group mb-lg-0">
        <label class="w-100 control-label">Loan Officer</label>
        <p-select
          [options]="allLoanOfficers()"
          [optionLabel]="'username'"
          [optionValue]="'userId'"
          formControlName="loanOfficerName"
          id="loanOfficerName"
          class="w-100"
          placeholder="Select"
          appendTo="body"
        />
      </div>
    </div>
    <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="form-group mb-lg-0">
        <label class="w-100 control-label">Origination Channel</label>
        <p-select
          class="w-100"
          id="originationChannel"
          formControlName="originationChannel"
          [options]="organizationChannelOptions"
          [optionLabel]="'name'"
          [optionValue]="'value'"
          placeholder="Select"
          appendTo="body"
        />
      </div>
    </div>
  </div>
  @if (errorMessage) {
    <div class="row mt-3">
      <div class="col">
        <p-message severity="error">
          <span [innerHTML]="errorMessage"></span>
        </p-message>
      </div>
    </div>
  }
  <div class="row mt-3">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 upload-container">
      @if (!uploadedFile) {
        <cmg-clear2-ui-file-uploader-34
          [placeholder]="'Upload Document'"
          [customIcon]="'fa fa-file-upload fs-2 light-gray'"
          (filesAdded)="filesAdded($event)"
        />
      }
      <div class="d-flex justify-content-end">
        @if (uploadedFile) {
          <label class="uploaded-file-label">{{ uploadedFile.filename }}</label>
        }
      </div>
      <!--
      <button pButton type="button" *ngIf="uploadedFile" (click)="onClearUpload()">
        <span pButtonIcon class="p-dialog-header-close-icon pi pi-times"></span>
      </button>
      -->
      @if (uploadedFile) {
        <p-button class="remove-button" type="button" icon="pi pi-times" severity="danger" (click)="onClearUpload()" />
      }
    </div>
  </div>
</form>
<br />
<div class="dialog-button-container">
  <button pButton type="button" (click)="closeDialog()" severity="secondary">
    <span pButtonLabel>Cancel</span>
  </button>
  <button
    pButton
    type="button"
    [disabled]="!selectedLoanOfficer?.username || !uploadedFile"
    (click)="uploadedFile ? uploadfiles() : $event.stopPropagation()"
  >
    <span pButtonLabel>Upload</span>
  </button>
</div>
@if (isLoading$ | async) {
  <cmg-clear2-ui-busy-indicator [loadingMessage]="loadingMessage$ | async" />
}
